export default {
  secondary: 'פעולות נוספות',
  count: 'מציג פריטים {1} עד {2} מתוך {3}',
  selected: '{1} פריטים נבחרו',
};
